import { FC, lazy, LazyExoticComponent, Suspense, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useOptionsContext, usePageContext } from '@sleepunique/context';
import { SleepUniqueOptions } from '@sleepunique/types/config-types';

const MissingPage = lazy(() => import('./View/MissingPage'));

export const views: {
  [name: string]: LazyExoticComponent<FC>;
} = {
  start: lazy(() => import('./View/Start')),
  intro: lazy(() => import('./View/Intro')),
  sleepers: lazy(() => import('./View/Sleepers')),
  mattressSize: lazy(() => import('./View/MattressSize')),
  name: lazy(() => import('./View/Name')),
  bodyMeasurements: lazy(() => import('./View/BodyMeasurements')),
  weight: lazy(() => import('./View/Weight')),
  height: lazy(() => import('./View/Height')),
  waist: lazy(() => import('./View/Waist')),
  sleepPosition: lazy(() => import('./View/SleepPosition')),
  sleepGoal: lazy(() => import('./View/SleepGoal')),
  sharedSleepGoal: lazy(() => import('./View/SharedSleepGoal')),
  sleepProfile: lazy(() => import('./View/SleepProfile')),
  calculatingResults: lazy(() => import('./View/CalculatingResults')),
  results: lazy(() => import('./View/Results')),
};

declare global {
  interface Window {
    SNG_SLEEP_UNIQUE_OPTIONS: SleepUniqueOptions;
  }
}

const Main: FC = (props) => {
  const { page } = usePageContext();
  const { setConfig } = useOptionsContext();

  useEffect(() => {
    const options = window.SNG_SLEEP_UNIQUE_OPTIONS!;

    setConfig!(options);
  });

  const Component: any = views?.[page] || MissingPage;

  return Component ? (
    <Suspense fallback={<span />}>
      <Component key={page} {...props} />
    </Suspense>
  ) : null;
};

export default Main;
